<!-- Traditional booking grid -->
@if (tripType() !== TripType.MULTICITY) {
  <div
    class="selector-grid grid-col-12 no-gutters"
    data-testid="booking-widget"
    [ngClass]="[layout(), isGlobalBookingWidget() ? WidgetTheme.DARK : WidgetTheme.LIGHT]"
  >
    <fin-trip-type-selector
      [isGlobalBookingWidget]="isGlobalBookingWidget()"
      [returnDateMissing]="!travelDates()?.returnDate"
      [isSearchEnabled]="shouldSearchBeEnabled$ | async"
      (setTripType)="setTripType($event)"
      (startSearch)="startSearch()"
      (openCalendar)="openCalendar()"
    />
    <fin-location-selector
      [locationPair]="locations()"
      [showPreviousSearches]="true"
      [disabled]="disableOnDSelection()"
      (setLocations)="setLocations($event)"
      [isGlobalBookingWidget]="isGlobalBookingWidget()"
      (locationsSwitched)="startSearch()"
      (startSearch)="startSearch()"
    />

    @if ((showCompact$ | async) === false || isGlobalBookingWidget()) {
      <fin-pax-amount-selector
        [enableNewSearchAutomatically]="isGlobalBookingWidget()"
        (setPaxAmount)="setPaxAmount($event)"
        (startSearch)="startSearch()"
        [isSearchEnabled]="shouldSearchBeEnabled$ | async"
      />
      <fin-travel-dates-selector
        [tripType]="tripType()"
        [travelClass]="travelClass()"
        [paxAmount]="paxAmount()"
        [locations]="locations()"
        [travelDates]="travelDates()"
        [priceCalendarType]="
          bookingFlowType() === WidgetTab.AWARD ? PriceCalendarType.ONLY_DATES : PriceCalendarType.PRICES
        "
        [isOneway]="tripType() === TripType.ONEWAY"
        [showAddReturn]="tripType() === TripType.ONEWAY"
        [enableNewSearchAutomatically]="isGlobalBookingWidget()"
        [showFlexibleDatesSelection]="showFlexibleDatesSelection$ | async"
        [showTripPriceFrom]="showTripPriceFrom$ | async"
        (setTravelDates)="setTravelDates($event, false)"
        (setFlexibleDates)="setFlexibleDates($event)"
        (addReturn)="onAddReturnClick()"
        [isSearchEnabled]="shouldSearchBeEnabled$ | async"
        (startSearch)="startSearch()"
        (cancelSelection)="cancelTravelDatesSelection()"
      />
    }
  </div>
}

<!-- Multicity booking grid -->
@if (tripType() === TripType.MULTICITY) {
  <div data-testid="booking-widget-multicity" class="selector-grid multicity grid-col-12 no-gutters ms-small-b">
    <fin-trip-type-selector [isGlobalBookingWidget]="isGlobalBookingWidget()" (setTripType)="setTripType($event)" />
    <fin-pax-amount-selector (setPaxAmount)="setPaxAmount($event)" />
  </div>
  <fin-multicity-selector data-testid="multi-city-selector" />
}
<!-- Footer -->
@if ((showCompact$ | async) === false || isGlobalBookingWidget() || tripType() === TripType.MULTICITY) {
  <div
    #footer
    class="footer ps-medium-t"
    [class.flex]="layout() === WidgetLayout.HORIZONTAL"
    [ngClass]="{
      'flex flex--space-between flex--middle white-text text-icon-reversed':
        layout() === WidgetLayout.HORIZONTAL && bookingFlowType() !== WidgetTab.AWARD,
      'flex--end': layout() === WidgetLayout.HORIZONTAL && bookingFlowType() === WidgetTab.AWARD,
    }"
    data-testid="booking-widget-footer"
  >
    @if (showDiscountCode$ | async) {
      <div [class.ps-medium-b]="!isGlobalBookingWidget()">
        <fin-discount-code [isGlobalBookingWidget]="isGlobalBookingWidget()" (startSearch)="startSearch()" />
      </div>
    }
    <div class="flex flex--middle flex--end">
      @if ((hideFooterPrice$ | async) === false) {
        <div class="flex-2" data-testid="booking-widget-footer-price">
          <div class="regular-type font-body-medium">
            {{
              (tripType() === TripType.ONEWAY
                ? 'bookingWidget.priceCalendar.oneWayPerAdult'
                : 'bookingWidget.priceCalendar.roundTripPerAdult'
              ) | finLocalization
            }}
          </div>
          <div class="nordic-900-text text-icon-accent bold-type font-title-medium">
            {{ startingPrice$ | async | finPrice: { stripZeroCents: true, useSymbol: true } | finEmpty: '&ndash;' }}
          </div>
        </div>
      }

      @if (!isGlobalBookingWidget()) {
        <fcom-button
          class="continue-btn"
          [class.ps-xxsmall-b]="isGlobalBookingWidget()"
          [theme]="ButtonTheme.PRIMARY_ACCENT"
          [size]="ButtonSize.LARGE"
          [mode]="ButtonMode.FILL"
          [loading]="loading$ | async"
          [aria]="{ loadingLabel: 'actions.loading' | finLocalization }"
          [text]="(isGlobalBookingWidget() ? 'bookingSearch.startNewSearch' : 'bookingSearch.search') | finLocalization"
          [disabled]="isGlobalBookingWidget() ? (isNewSearchEnabled$ | async) === false : continueEnabled() === false"
          (clickBtn)="startSearch()"
          data-testid="booking-widget-search-button"
        />
      }
    </div>
  </div>
}
<fin-booking-widget-notifications
  [ngClass]="{ 'white-text text-icon-reversed': isGlobalBookingWidget() }"
  [locations]="flights()"
  [tripType]="tripType()"
  [profile]="profile()"
/>
<fin-air-calendar
  [paxAmount]="paxAmount()"
  [travelDates]="travelDates()"
  [tripType]="tripType()"
  [prices]="airCalendarPrices()"
  [isAward]="bookingFlowType() === WidgetTab.AWARD"
  [totalPoints]="profile()?.awardPoints"
  (selectDates)="setTravelDates($event, true)"
  (continue)="navigateToBookingFlow(true)"
/>
